// Client-side validation: requires HTTPS only.
// Additional restrictions (localhost, private IPs, etc.) are enforced server-side.
export default function isValidWebhookUrl(url) {
  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
